import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IProfession } from '../interfaces/profession/iprofession';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfessionService {
  constructor(private http: HttpClient) {}
  

  getAll(professionCategory?:string) {
    let urlSearchParams = new URLSearchParams();
    if(professionCategory) {
      urlSearchParams.append('professionCategory', professionCategory)
    }

    return this.http.get(`${environment.url}/professions?${urlSearchParams.toString()}`).pipe(map((res: any) => res['hydra:member'])) as Observable<
      IProfession[]
    >;
    // .pipe(map((res: any) => res['hydra:member']))
  }

  save(req: IProfession) {
    return this.http.post(
      `${environment.url}/professions`,
      req
    ) as Observable<IProfession>;
  }

  edit(req: IProfession, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`${environment.url}/professions/${id}`, req, {
      headers: headers,
    }) as Observable<IProfession>;
  }

  delete(id: number) {
    return this.http.delete(
      `${environment.url}/professions/${id}`
    ) as Observable<IProfession>;
  }
}
